import { render, staticRenderFns } from "./CustomerTreatmentListAddNew.vue?vue&type=template&id=0f1d80ad&"
import script from "./CustomerTreatmentListAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerTreatmentListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTreatmentListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports